import { faCircle, faUserEdit } from '@fortawesome/free-solid-svg-icons';
import { faComment } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { Badge } from 'reactstrap';
import moment from 'moment';

const CommunicationListItem = ({
    practiceId,
    isSelected,
    communicationId,
    communicationTitle,
    communicationType,
    notificationCount,
    commentCount,
    communicationIsOpen, 
    displayId,
    createdByFirstName,
    createdByLastName,
    createdDate
}) => {
    let itemClasses = 'communication-list-item rounded p-2 my-3';
    if (isSelected) itemClasses += ' sc-glass rounded';
    let spanClass = notificationCount === 0 ? 'invisible' : '';
    let iconClass = communicationIsOpen === true ? 'text-success' : 'text-danger';
    return (
        <Link
            className="text-decoration-none text-light"
            to={`/practices/${practiceId}/communications/${communicationId}`}>
            <div className={itemClasses}>
                <div className="d-flex justify-content-between mb-2">
                    <h6>{communicationTitle || communicationType}</h6>
                    <div className="text-nowrap">
                        <span className={spanClass}>
                            <Badge color="danger">
                                {notificationCount}
                            </Badge>
                            &emsp;
                        </span>
                        <FontAwesomeIcon icon={faComment} />
                        &nbsp;{commentCount}
                    </div>
                </div>
                <div className="op-7 text-14 d-flex justify-content-between">
                    <div>
                        <FontAwesomeIcon
                            icon={faCircle}
                            size="sm"
                            className={iconClass}
                        />
                        &nbsp;
                        {communicationIsOpen ? 'Open' : 'Closed'}
                        &emsp; #{displayId}
                    </div>
                    <span
                        title={`Created by ${createdByFirstName} ${createdByLastName}`}>
                        <FontAwesomeIcon icon={faUserEdit} size="sm" />
                        &nbsp;{createdByFirstName}{' '}
                        {createdByLastName}{' '}
                        {moment.unix(createdDate).fromNow()}
                    </span>
                </div>
            </div>
        </Link>
    );
};

export default CommunicationListItem;
